module.exports = __webpack_public_path__ + "static/media/mx-linux_overlay-fs8.0a8a4591.png";